import React, { useRef, useState } from 'react';

function fmt(sec) {
  sec = Math.max(0, Math.round(sec));
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  const s = sec % 60;
  const mm = h ? String(m).padStart(2, '0') : String(m);
  return `${h ? h + ':' : ''}${mm}:${String(s).padStart(2, '0')}`;
}

/** Seek bar with elapsed / remaining timestamps. Click or drag to seek. */
export function Scrubber({ value = 0, duration = 0, onSeek, showTimes = true, className = '' }) {
  const trackRef = useRef(null);
  const [drag, setDrag] = useState(null);
  const shown = drag != null ? drag : value;
  const pct = duration ? Math.min(100, Math.max(0, (shown / duration) * 100)) : 0;

  const posFromEvent = (e) => {
    const r = trackRef.current.getBoundingClientRect();
    const p = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
    return p * duration;
  };
  const down = (e) => {
    if (!duration) return;
    e.currentTarget.setPointerCapture(e.pointerId);
    setDrag(posFromEvent(e));
  };
  const move = (e) => { if (drag != null) setDrag(posFromEvent(e)); };
  const up = () => {
    if (drag == null) return;
    if (onSeek) onSeek(drag);
    setDrag(null);
  };

  return (
    <div className={`bjl-scrubber ${drag != null ? 'is-dragging' : ''} ${className}`}>
      {showTimes ? <span className="bjl-scrubber__time">{fmt(shown)}</span> : null}
      <div
        ref={trackRef}
        className="bjl-scrubber__track"
        role="slider"
        aria-valuemin={0}
        aria-valuemax={Math.round(duration)}
        aria-valuenow={Math.round(shown)}
        aria-label="播放进度"
        onPointerDown={down}
        onPointerMove={move}
        onPointerUp={up}
      >
        <span className="bjl-scrubber__rail"></span>
        <span className="bjl-scrubber__fill" style={{ width: pct + '%' }}></span>
        <span className="bjl-scrubber__handle" style={{ left: pct + '%' }}></span>
      </div>
      {showTimes ? <span className="bjl-scrubber__time">-{fmt(duration - shown)}</span> : null}
    </div>
  );
}
